import type {
  SwitchChangeFn,
  SwitchProps,
} from '../../../components/Switch/Switch';

import Switch from '../../../components/Switch/Switch';

import useYjsField from '../../collaboration/useYjsField';
import { useFieldContext } from '../../form';
import { useFieldErrors } from '../../useFieldErrors';

const SwitchField = ({ disabled, onFocus, onBlur, ...props }: SwitchProps) => {
  const field = useFieldContext<boolean>();
  const errors = useFieldErrors(field.name);
  const yjsField = useYjsField('raw');

  const onChange: SwitchChangeFn = (e) => {
    field.handleChange(e.target.value);
    yjsField.update(e.target.value);
  };

  const onFieldFocus = (e: { target: { name: string } }) => {
    onFocus?.(e);
    yjsField.onFocus();
  };

  const onFieldBlur = (e: { target: { name: string } }) => {
    onBlur?.(e);
    field.handleBlur();
    yjsField.onBlur();
  };

  return (
    <Switch
      {...props}
      name={field.name}
      checked={field.state.value}
      onChange={onChange}
      error={errors}
      onFocus={onFieldFocus}
      onBlur={onFieldBlur}
      disabled={disabled || !!yjsField.isBeingEdited}
      editors={yjsField.fieldEditors}
    />
  );
};

export default SwitchField;
